export const FETCH_POST='FETCH_POST';
export const NEW_POST='NEW_POST';
export const UPDATE_POST='UPDATE_POST';
export const ADD_POST='ADD_POST';
export const FETCH_DETAIL='FETCH_DETAIL';
export const FETCH_COST='FETCH_COST';
export const FETCH_SOLUTION='FETCH_SOLUTION';
